import { Component, OnInit, Inject, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CardDetails, OrdersWithPayment, Order, OccasionDetail, BotOrder } from 'src/app/models/order';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { PaymentMethodsBottomSheetComponent } from '../payment-methods-bottom-sheet/payment-methods-bottom-sheet-component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import * as moment from 'moment';
import { extendMoment } from 'moment-range';
import { OrderService } from '../../order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, Table } from 'src/app/models/store';
import PlaceResult = google.maps.places.PlaceResult;
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { PaymentOption, PaymentOptionService } from 'src/app/_services/payment-option.service';
import { BooleanService } from 'src/app/_services/boolean.service';
import { Subscription, Observable, of } from 'rxjs';
import { OccasionDetailService } from 'src/app/_services/occasion-detail.service';

type OccasionCode = 'PICKUP' | 'CURBSIDE' | 'DELIVERY' | 'DINE IN' | 'TABLESIDE';

const { range } = extendMoment(moment);

@Component({
  selector: 'schedule-bottom-sheet',
  templateUrl: './schedule-bottom-sheet.html',
  styleUrls: ['./schedule-bottom-sheet.scss']
})
export class ScheduleBottomSheetComponent implements OnInit, OnDestroy {

  occasion;
  orderHash: string;
  occasionTime: string;
  scheduledDate;
  scheduledTime;
  dateRange: Date[] = [];
  timeRange: moment.Moment[] = [];
  leadTime = 0;
  scheduleError: string | null = null;
  deliveryAddress;
  dineInTableId;
  curbsideVehicleId;
  store: Store;
  latitude;
  longitude;
  hasPlacedTablesideOrder;
  locationSelected = false;
  // Payment Bottom Sheet
  isLoading = true;
  guestCardDetails: CardDetails[];
  storeCredit = 0;
  paymentGateway;
  storeId: string;
  phoneNumber: string;
  orderWithPayment: OrdersWithPayment;
  selectedPaymentMethod;

  storeEndpointV2: string;

  @ViewChild('deliveryAddressInput', { static: false }) deliveryAddressInput: ElementRef;

  paymentOption: PaymentOption;
  paymentServiceSub: Subscription;
  updatedDate;
  occasionDetail: OccasionDetail;

  initial = true;

  tables: Table[]
  filteredTables

  serviceAreas;
  serviceAreaLabel: string;
  doordash_delivery_drive: boolean = false;

  occasionLabels: Record<OccasionCode, string> = {
    PICKUP: 'Pickup',
    CURBSIDE: 'Curbside',
    DELIVERY: 'Delivery',
    'DINE IN': 'Dine In',
    TABLESIDE: 'Tableside'
  };
  orderedOccasions: OccasionCode[] = [];


  constructor(
    private bottomSheet: MatBottomSheet,
    private bottomSheetRef: MatBottomSheetRef<ScheduleBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private orderService: OrderService,
    private paymentOptionService: PaymentOptionService,
    private ref: ChangeDetectorRef,
    private occasionDetailService: OccasionDetailService) {
    let botOrder: BotOrder = data.orderWithPayment.bot_order;
    let store = data.orderWithPayment.store;

    this.occasionDetail = data.occasionDetail || data.orderWithPayment.getOccasionDetail()
    this.orderHash = botOrder.order_hash;
    this.store = store
    this.hasPlacedTablesideOrder = data.hasPlacedTablesideOrder;
    this.orderWithPayment = data.orderWithPayment;
    this.paymentOption = data.paymentOption
    // Re-opening an already scheduled order: seed the pickers from the saved instant (store wall clock)
    if (this.occasionDetail.time === 'LATER' && this.occasionDetail.occasion_schedule) {
      const wall = moment(this.store.convertTZ(this.occasionDetail.occasion_schedule));
      if (wall.isValid()) {
        this.scheduledDate = wall.format('YYYY-MM-DD');
        this.scheduledTime = wall.format('HH:mm');
      }
    }
    this.buildTimeRange()
  }

  ngOnInit() {
    this.getFeatureFlagStatus();
    this.paymentServiceSub = this.paymentOptionService.current.subscribe(paymentOption => {
      if (paymentOption) {
        this.paymentOption = paymentOption;
      }
      this.ref.detectChanges()
    })

    this.orderService.getTablesideTables(this.store.id).subscribe(tables => {
      this.tables = tables;
      this.filteredTables = tables;
    })

    this.orderService.getServiceAreas(this.store.id).subscribe(data => {
      this.serviceAreas = data;
      const multiEnabled = !!(this.store['feature_flag']['multi_delivery_radius_charge_feature']);
      const unit = 'Miles';
      if (data.service_type === 'RADIUS') {
        if (multiEnabled) {
          const tiers = data.radiuses || [];
          const sortedRadii = tiers.map((t: any) => Number(t.radius)).filter(n => n > 0).sort((a, b) => a - b);
          const maxRadius = sortedRadii.reduce((m, n) => Math.max(m, n), 0);
          const breakdown = sortedRadii.length ? ` (${sortedRadii.join(' / ')} ${unit})` : '';
          this.serviceAreaLabel = `Delivery Radius: ${maxRadius} ${unit}${breakdown}`;
        } else {
          this.serviceAreaLabel = `Delivery Radius: ${data.radius} ${unit}`;
        }
      } else {
        this.serviceAreaLabel = `Delivering ${data.areas.map((p: any) => p.name).join(', ')}`;
      }
    });

    this.initial = localStorage.getItem(`${this.orderHash}_occasionInitial`) !== 'false'
    if (localStorage.getItem('curbside_vehicle_id')) {
      this.occasionDetail.curbside_vehicle_id = localStorage.getItem('curbside_vehicle_id')
    }
    this.isLoading = true;
    this.orderedOccasions = this.computeOrderedVisibleOccasions();
    this.buildTimeRange(this.occasion)

    // When store is closed, force LATER and reset schedule so user picks date/time
    if (this.canSubmitOnlyFutureOrder() && this.occasionDetail.occasion && this.occasionDetail.occasion !== 'TABLESIDE') {
      this.occasionDetail.time = 'LATER';
      this.occasionDetail.occasion_schedule = null;
      this.scheduledTime = null;
    }
  }

  filterTables(event) {
    this.filteredTables = this.tables.filter(table => table.table_name.toLowerCase().indexOf(event.target.value.toLowerCase()) === 0);
  }

  ngOnDestroy() {
    this.paymentServiceSub.unsubscribe();
  }

  checkOccasion() {
    // When store is closed, force LATER and reset schedule so user picks date/time
    if (this.canSubmitOnlyFutureOrder() && this.occasionDetail.occasion !== 'TABLESIDE') {
      this.occasionDetail.time = 'LATER';
      this.occasionDetail.occasion_schedule = null;
      this.scheduledTime = null;
    }
  }

  computeOrderedVisibleOccasions(): OccasionCode[] {
    if (!this.store) return [];

    const MAP: Record<string, OccasionCode> = {
      has_order_occasion_pickup: 'PICKUP',
      has_order_occasion_curbside: 'CURBSIDE',
      has_order_occasion_delivery: 'DELIVERY',
      has_order_occasion_dine_in: 'DINE IN',
      has_order_occasion_tableside: 'TABLESIDE',
      PICKUP: 'PICKUP',
      CURBSIDE: 'CURBSIDE',
      DELIVERY: 'DELIVERY',
      'DINE IN': 'DINE IN',
      TABLESIDE: 'TABLESIDE'
    };

    const DEFAULT: OccasionCode[] = ['PICKUP', 'DINE IN', 'TABLESIDE', 'DELIVERY', 'CURBSIDE'];

    let order: OccasionCode[] = [];
    const raw = this.store?.store_data?.occasion_list_order;

    if (raw) {
      try {
        const arr = JSON.parse(raw.replace(/'/g, '"'));
        if (Array.isArray(arr)) {
          order = Array.from(new Set(arr.map(k => MAP[k]).filter(Boolean))) as OccasionCode[];
        }
      } catch { /* ignore and fallback */ }
    }

    const base = order.length ? order : DEFAULT;
    for (const k of DEFAULT) if (!base.includes(k)) base.push(k);

    const isCatering = this.orderWithPayment?.bot_order?.is_catering || false;
    const flags = (this.store as any)?.getOccasionFlags
      ? this.store.getOccasionFlags(isCatering)
      : (this.store as any)?.occasion_flags_online || {};
    return base.filter(code => !!flags[code]);
  }

  onTimeChange(value: string) {
    this.occasionDetail.time = value;
    this.scheduleError = null;
    if (value === 'LATER') {
      this.scheduledTime = null;
      this.occasionDetail.occasion_schedule = null;
      this.buildTimeRange(); // rebuild date/time options fresh
    } else {
      this.occasionDetail.occasion_schedule = null;
    }
    this.ref.detectChanges();
  }

  /** When user picks a date, reset time and rebuild time slots */
  onDateSelected(date: string) {
    this.scheduledTime = null;
    this.occasionDetail.occasion_schedule = null;
    this.scheduleError = null;
    this.buildTimeRange(date);
  }

  /** Keep occasionDetail.occasion_schedule in sync so isValid() works for LATER */
  syncOccasionSchedule() {
    const wall = this.selectedWallClock();
    this.occasionDetail.occasion_schedule = wall ? this.store.toStoreInstant(wall).toISOString() : null;
  }

  /** Selected date + time as a store wall-clock Date, or null when incomplete. */
  private selectedWallClock(): Date | null {
    if (!this.scheduledDate || !this.scheduledTime) { return null; }
    const m = moment(this.scheduledDate + ' ' + this.scheduledTime, 'YYYY-MM-DD HH:mm', true);
    return m.isValid() ? m.toDate() : null;
  }

  /**
   * Build the selectable dates (next 7 open days) and the 15-minute time
   * slots for the selected date. Every slot is checked against store hours,
   * holidays/special hours and the occasion lead time on the store's clock,
   * so the list only ever contains times the kitchen can actually honour.
   */
  buildTimeRange(date = '') {
    this.leadTime = this.store.getLeadTime(this.occasionDetail.occasion);

    const firstOpen = this.findFirstOpenDate(this.store.storeNow());
    const endDate = moment(firstOpen).add(7, 'days').toDate();
    const allDates = Array.from(range([firstOpen, endDate]).by('day')).map(d => d.toDate());
    this.dateRange = allDates.filter(d => this.buildSlotsFor(d).length > 0);

    if (date) { this.scheduledDate = date; }
    const available = this.dateRange.map(d => moment(d).format('YYYY-MM-DD'));
    if (!this.scheduledDate || !available.includes(this.scheduledDate)) {
      this.scheduledDate = available[0] || null;
      this.scheduledTime = null;
    }
    this.timeRange = this.scheduledDate ? this.buildSlotsFor(moment(this.scheduledDate, 'YYYY-MM-DD').toDate()) : [];

    // Drop a previously picked time that is no longer offered (e.g. lead time moved past it)
    if (this.scheduledTime && !this.timeRange.some(t => t.format('HH:mm') === this.scheduledTime)) {
      this.scheduledTime = null;
      this.occasionDetail.occasion_schedule = null;
    }
  }

  private buildSlotsFor(day: Date): moment.Moment[] {
    const start = moment(day).startOf('day');
    const slots: moment.Moment[] = [];
    for (let i = 0; i < 24 * 4; i++) {
      const slot = start.clone().add(15 * i, 'minutes');
      if (this.store.is_open_on(slot.toDate(), this.leadTime)) { slots.push(slot); }
    }
    return slots;
  }

  haversineDistance(mk1, mk2) {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = mk1.lat() * (Math.PI / 180); // Convert degrees to radians
    var rlat2 = mk2.lat() * (Math.PI / 180); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = (mk2.lng() - mk1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
    return d;
  }

  trigerSubmit(event: any) {
    this.onSubmit();
  }

  closeSheet() {
    this.bottomSheetRef.dismiss("cancel");
  }

  onSubmit() {
    if (this.occasionDetail.time === 'LATER') {
      const wall = this.selectedWallClock();
      if (!wall) {
        this.scheduleError = 'Please choose a date and time.';
        this.ref.detectChanges();
        return;
      }
      this.updatedDate = this.store.toStoreInstant(wall);
      this.occasionDetail.occasion_schedule = this.updatedDate;
    } else {
      this.updatedDate = null;
      this.occasionDetail.occasion_schedule = null;
    }
    this.scheduleError = null;
    if (this.occasionDetail.curbside_vehicle_id) {
      localStorage.setItem('curbside_vehicle_id', this.occasionDetail.curbside_vehicle_id)
    }
    this.orderService.updateOccasionSchedule(this.orderHash, this.occasionDetail).subscribe(data => {
      this.orderWithPayment.setOccasionDetail(this.occasionDetail);
      this.occasionDetailService.updateOccasionDetail(this.occasionDetail);
      localStorage.setItem(`${this.orderHash}_occasionInitial`, 'false')
      this.bottomSheetRef.dismiss(this.occasionDetail);
    }, (error) => {
      // Backend re-validates hours + lead time; refresh the slots and let the user pick again.
      this.scheduleError = error?.error?.error || 'That time is no longer available. Please pick another.';
      this.scheduledTime = null;
      this.occasionDetail.occasion_schedule = null;
      this.buildTimeRange();
      this.ref.detectChanges();
    })
  }

  getFeatureFlagStatus(): void {
    const storeId = this.store.id;

    this.orderService.GetFeatureFlag(storeId).subscribe(response => {
      this.doordash_delivery_drive = response.feature_flag;
    }, error => {
    });
  }

  onAddressSelected(result: PlaceResult) {
  }

  private pickRadiusTier(distance: number) {
    const tiers = this.serviceAreas?.radius_tiers ?? this.serviceAreas?.radiuses ?? [];
    return tiers.find((t: any) => distance <= Number(t.radius)) || null;
  }

  // OPTIONAL: upgrade signature to pass an explicit charge when needed (multi-radius)
  updateDeliveryAddress(address: string, isSelected: boolean, charge?: number) {
    this.deliveryAddress = address;
    this.occasionDetail.delivery_address = address;
    this.occasionDetail.location_selected = isSelected;
    this.locationSelected = isSelected;

    if (isSelected) {
      const fee = (typeof charge === 'number')
        ? charge
        : (this.orderWithPayment?.store?.delivery_charge ?? 0);

      this.orderService
        .updateDeliveryFee(this.orderWithPayment.bot_order.id, fee)
        .subscribe(() => this.ref.detectChanges());
    }
  }

  onAutocompleteSelected(result: google.maps.places.PlaceResult) {
    if (!result?.geometry?.location) {
      alert('Could not read the selected location. Please pick again.');
      return;
    }

    // 1) DoorDash Delivery Drive branch (keep staging behavior)
    if (this.doordash_delivery_drive) {
      this.createDoordashDeliveryQuote(this.orderHash, {
        pickup_address: this.store.address,
        delivery_address: result.formatted_address
      });
      return;
    }

    // 2) Normal flow
    if (this.store.gmb_location_id) {
      if (this.serviceAreas?.service_type === 'RADIUS') {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ placeId: this.store.gmb_location_id }, (storeResult, status) => {
          if (status !== 'OK' || !storeResult?.length) return;

          const storeLocation = storeResult[0].geometry.location!;
          const deliveryLocation = result.geometry!.location!;
          const deliveryDistance = this.haversineDistance(storeLocation, deliveryLocation); // units must match radius units

          // Single source of truth for mode
          const multiEnabled = !!(this.store['feature_flag']['multi_delivery_radius_charge_feature']);

          if (multiEnabled) {
            // 2a) MULTI-RADIUS (tiers only, no fallback to single)
            const tier = this.pickRadiusTier(deliveryDistance);
            if (tier) {
              this.updateDeliveryAddress(result.formatted_address!, true, Number(tier.charge) || 0);
            } else {
              this.handleOutOfRangeAddress(result.formatted_address!);
            }
          } else {
            // 2b) SINGLE-RADIUS legacy (preserve staging’s 15mi override logic if DD flag ever leaks here)
            const deliveryRadius = this.store['feature_flag']['doordash_delivery_drive'] ? 15 : Number(this.serviceAreas.radius) || 0;
            if (deliveryDistance <= deliveryRadius) {
              this.updateDeliveryAddress(result.formatted_address!, true);
            } else {
              this.handleOutOfRangeAddress(result.formatted_address!);
            }
          }
        });

        console.log('onAutocompleteSelected: ', result);
      } else {
        // NON-RADIUS (city/ZIP) – keep staging behavior
        this.validateServiceArea(result);
      }
    } else {
      // No GMB placeId: accept address (no distance validation)
      this.updateDeliveryAddress(result.formatted_address!, true);
    }
  }

  // Staging helpers kept as-is
  createDoordashDeliveryQuote(orderId: string, payload: any) {
    this.orderService.DoordashCreateDeliveryAdd(orderId, payload).subscribe(
      (response) => {
        const message = (response as any).msg.message;
        if (message === 'Allowed distance between addresses exceeded' || message === 'Validation Error') {
          this.handleOutOfRangeAddress(payload.delivery_address);
        } else {
          this.updateDeliveryAddress(payload.delivery_address, true);
        }
      },
      () => alert('An error occurred while checking the delivery range. Please try again.')
    );
  }


  handleValidDelivery(result: PlaceResult, charge: number) {
    this.deliveryAddress = result.formatted_address;
    this.occasionDetail.delivery_address = result.formatted_address;
    this.occasionDetail.location_selected = true;
    this.orderService.updateDeliveryFee(this.orderWithPayment.bot_order.id, charge)
      .subscribe(() => {
        this.ref.detectChanges();
      });
  }

  handleOutOfRangeAddress(address: string) {
    alert(`Your address '${address}' is out of range for delivery.`);
    this.updateDeliveryAddress(undefined, false);
    this.deliveryAddressInput.nativeElement.focus();
  }

  validateServiceArea(result: PlaceResult) {
    let areas = this.serviceAreas.areas;
    let levels = result.address_components.map(ac => this.getAc(ac));
    console.log(areas);
    this.occasionDetail.location_selected = false;

    areas.forEach(area => {
      let matches = area.levels.map(al => {
        let gLevel = this.getAreaType(al.type, levels);
        return gLevel && gLevel.long_name === al.long_name;
      });

      if (matches.every(b => b) && !this.occasionDetail.location_selected) {
        this.updateDeliveryAddress(result.formatted_address, true);
      }
    });

    if (!this.occasionDetail.location_selected) {
      console.log("Address is out of range for delivery.");
      this.handleOutOfRangeAddress(result.formatted_address);
    }
  }

  checkEq(left, right) {
    return left == right
  }

  getAc(v) {
    return { 'long_name': v.long_name, 'short_name': v.short_name, 'type': v.types[0] }
  }

  getAreaType(key, obj) {
    return obj.find(a => a.type === key)
  }

  getPlainPhoneNumber() {
    if (this.phoneNumber) {
      let ph = this.phoneNumber.replace(/[\s()-]/g, '')
      return '+1' + ph.substring(0, 10)
    }
    return "";
  }

  openScheduleBottomSheet(orderWithPayment, data) {
    this.bottomSheet.open(ScheduleBottomSheetComponent, {
      panelClass: 'schedule-bottom-sheet-container',
      data: {
        orderWithPayment: orderWithPayment,
        paymentOption: data.paymentOption,
        occasionDetail: data.occasionDetail
      }
    })
  }

  addCard() {
    this.isLoading = true;
    this.orderService.getCards(this.store.id,
      this.orderWithPayment.bot_order.phone_number,
      this.orderWithPayment.store.payment_gateway).subscribe(data => {
        this.guestCardDetails = data['cards'].map(o => Object.assign(new CardDetails(), o));
        this.storeCredit = data['store_credit']
        this.isLoading = false;
      },
        (error) => {
          this.guestCardDetails = []
          this.storeCredit = error.error.store_credit
          this.isLoading = false
        }).add(() => {
          this.bottomSheet.open(PaymentMethodsBottomSheetComponent, {
            panelClass: 'payment-bottom-sheet-container',
            disableClose: !this.paymentOption.hasPaymentOption(),
            data: {
              orderHash: this.orderWithPayment.bot_order.order_hash,
              phoneNumber: this.orderWithPayment.bot_order.phone_number,
              orderTotal: this.orderWithPayment.payment.total,
              storeCredit: this.storeCredit,
              cardDetails: this.guestCardDetails,
              paymentGateway: this.orderWithPayment.store.payment_gateway,
              storeId: this.orderWithPayment.store.id,
              parent: this,
              storeCreditEnabled: true,
              storeCashEnabled: this.store.enable_cash_payment,
              paymentOption: this.paymentOption,
              occasionDetail: this.occasionDetail,
              surcharge: this.store.surcharge_percent,
              payrocUsername: this.store.payroc_username,
              storeCardEnabled: this.store.has_card_payment,
              store: this.store
            }
          }).afterDismissed().subscribe(data => {
            if (data) {
              this.paymentOption = data.paymentOption
              this.occasionDetail = data.occasionDetail
              this.openScheduleBottomSheet(this.orderWithPayment, data)
            }
          });
        });
  }

  canSubmitOnlyFutureOrder() {
    return this.orderWithPayment.store.canScheduleOrders() && !this.store.is_open_now();
  }

  private findFirstOpenDate(base: Date): Date {
    let candidate = new Date(base);
    let safety = 0;

    while (this.store.is_closed_for_the_day(candidate) && safety < 31) {
      candidate = moment(candidate).add(1, 'day').toDate();
      safety++;
    }

    return candidate;
  }

}
